import logo from "../../../src/assets/Header/STM_logo.png";
const disclaimerData = {
  id: "disclaimer",
  title: "Disclaimer",
  content: [
    "Any information submitted on this page, including telephone or contact numbers, may be used by Scholastic Test Masters to make follow-up calls, SMS, or emails regarding your interest or query in Scholastic Test Masters products/services. Such follow-up communications, promotions, and marketing efforts by Scholastic Test Masters  shall be regarded as solicited calls and are exempt from any “Do Not Call” requests that may have been placed previously. ",
    "If a recipient’s telephone/contact number is provided by another person or submitted erroneously, Scholastic Test Masters shall not be held liable for any claims. The recipient may request Scholastic Test Masters to delete their details from its records. ",
  ],
};

const termsData = [
  {
    id: 1,
    title: "Acceptance of Terms and Conditions",
    content: [
      "Your access to and use of this website is governed exclusively by these Terms and Conditions. By using the website, you accept all terms, conditions, and disclaimers contained herein.",
      "If you do not agree with any part of these Terms and Conditions, you must immediately stop using the website.",
    ],
  },
  {
    id: 2,
    title: "Credit Card Details & Privacy Policy",
    content: [
      {
        subheading: "How we protect customer information",
        text: "All payment information is processed through a secured network. SSL encryption ensures that your credit/debit card information is unreadable during transmission.",
      },
      {
        subheading: "Processing of Customer Information",
        text: "Payments are processed via ICICI Bank, a secure and reputable third-party payment gateway. Scholastic Test Masters, as the merchant, does not receive credit/debit card information. We receive basic customer information such as name, email, and mailing address to process and fulfill orders.",
      },
    ],
  },
  {
    id: 3,
    title: "Cookies",
    content: [
      "Cookies are used to improve service quality, store user preferences, enhance search results, manage ads, and track user trends.",
    ],
  },
  {
    id: 4,
    title: "Legal Advice",
    content: [
      "The contents of www.scholastictestmasters.com do not constitute legal, financial, or professional advice. ",
      'All material is provided "as is" and should be used at your own discretion.',
    ],
  },
  {
    id: 5,
    title: "Change of Use",
    content: [
      {
        subheading: "STM reserves the right to",
        text: "Temporarily or permanently modify or remove the website or any part thereof without notice. Change these Terms and Conditions at any time; continued use after changes constitutes acceptance.",
      },
    ],
  },
  {
    id: 6,
    title: "Links to Third-Party Websites",
    content: [
      "The website may include links to third-party sites.",
      "These links do not imply endorsement, and we are not responsible for their content or availability.",
    ],
  },
  {
    id: 7,
    title: "Copyright",
    content: [
      "All intellectual property rights, including website design, text, graphics, software, and source code, are owned or licensed by Scholastic Test Masters. ",
      "Content is for personal, non-commercial use only. Reproduction or distribution without prior written consent is prohibited.",
    ],
  },
  {
    id: 8,
    title: "Linking to and from Other Websites",
    content: [
      {
        subheading: "Parties linking must not imply",
        text: "Imply endorsement without written consent, misrepresent their relationship with Scholastic Test Masters, or link from offensive, controversial, or infringing content.",
      },
      {
        subheading: "Linking to other websites is at your own risk",
      },
    ],
  },
  {
    id: 9,
    title: "Disclaimers and Limitation of Liability",
    content: [
      'The website is provided "as-is" without any express or implied warranties.',
      "Scholastic Test Masters is not liable for indirect or consequential losses, including business, profit, or data loss.",
      "We do not guarantee uninterrupted or error-free functionality, and are not responsible for viruses or other harmful components.",
      "Nothing limits liability for death or personal injury caused by negligence.",
      "Personal information will be treated confidentially and not shared with third parties. Requests for access or correction should be emailed to shailendra@siecindia.com. ",
    ],
  },
  {
    id: 10,
    title: "Indemnity",
    content: [
      "You agree to indemnify Scholastic Test Masters against all liabilities, legal fees, damages, or losses arising from your breach of these Terms and Conditions or use of the website.",
    ],
  },
  {
    id: 11,
    title: "Severance",
    content: [
      "If any provision is deemed invalid or unenforceable, it shall be severed without affecting the remaining Terms and Conditions, which remain in full force. ",
    ],
  },
  {
    id: 12,
    title: "Governing Law",
    content: [
      "These Terms and Conditions are governed by the laws of India.",
      "Users submit to the exclusive jurisdiction of Indian courts. ",
    ],
  },
  {
    id: 13,
    title: "Non Refund Policy",
    content: [
      {
        item: "This policy applies to all products and services purchased online via www.scholastictestmasters.com. It does not apply to classroom programs or offline payments.",
      },
      {
        heading: "1. Policy Overview",
        items: [
          "All sales of products and services on the website are final.",
          "Once a purchase is made, no refund requests will be entertained, irrespective of dispatch status or online access.",
          "Access to online products or services is considered acceptance of the terms, and all purchases are non-refundable.",
        ],
      },
      {
        heading: "2. Important Notes",
        items: [
          "Orders requiring physical dispatch or online access are non-refundable, even if the materials have not yet been dispatched or accessed.",
          "No deductions, partial refunds, or credits will be provided for any reason.",
          "All communications regarding refunds will not be entertained.",
        ],
      },
      {
        heading: "Contact",
        text: (
          <>
            For any queries related to purchases, please contact:{" "}
            <a
              className="font-semibold text-[#161719]"
              href="mailto:support@scholastictestmasters.com"
            >
              support@scholastictestmasters.com
            </a>
          </>
        ),
      },
    ],
  },
];
const Terms_Conditions = () => {
  return (
    <>
      <header className="fixed  bg-white w-full flex justify-center border-b border-[#E5E5E5] shadow-[0px_4px_10px_0px_#00000024]">
        <div className="">
          <div className="flex items-center justify-center gap-6 md:gap-10 px-4 md:px-8 py-4 ">
            <img
              src={logo}
              alt="STM - Scholastic Test Masters logo"
              className="h-10 w-auto select-none"
              draggable="false"
            />

            <h1 className="font-inter font-semibold text-[32px] leading-[100%] tracking-[0px] text-center text-[#572575]">
              Terms and Conditions
            </h1>
          </div>
        </div>
      </header>
      <main className="pt-28 p-12 space-y-6 font-inter">
        {/* Disclaimer */}
        <section className="p-6 rounded-xl shadow-sm bg-gradient-to-r from-[#FCF6FF] via-[#FBEAFF] to-[#F9F9F9] border-l-8 border-[#572575]">
          <h3 className="font-semibold text-[20px] mb-3 text-[#161719]">
            {disclaimerData.title}
          </h3>
          <div className="space-y-3">
            {disclaimerData.content.map((item, idx) => (
              <p
                key={idx}
                className="font-medium text-[#3F424C] text-[18px] leading-[150%]"
              >
                {item}
              </p>
            ))}
          </div>
        </section>

        {/* Terms Data */}
        {termsData.map((section, index) => (
          <section
            key={section.id}
            className="p-6 rounded-xl bg-white border border-gray-200 shadow-sm"
          >
            <header className="flex items-center gap-4 mb-4">
              <div className="h-8 w-8 flex items-center justify-center rounded-full bg-[#572575] text-white font-semibold text-sm">
                {(index + 1).toString().padStart(2, "0")}
              </div>
              <h3 className="font-semibold text-[20px] text-[#161719]">
                {section.title}
              </h3>
            </header>

            <div className="text-[18px] leading-[150%] space-y-3 text-[#3F424C]">
              {section.content.map((item, idx) => {
                // Normal paragraph
                if (typeof item === "string") {
                  return <p key={idx}>{item}</p>;
                }

                // Subheading + text
                if (item.subheading) {
                  return (
                    <p key={idx}>
                      <span className="text-[#572575] font-semibold">
                        {item.subheading}:
                      </span>{" "}
                      {item.text && (
                        <span className="font-medium">{item.text}</span>
                      )}
                    </p>
                  );
                }

                // List items
                if (item.items) {
                  return (
                    <div key={idx} className="space-y-2">
                      {item.heading && (
                        <h4 className="font-semibold text-gray-900">
                          {item.heading}
                        </h4>
                      )}
                      <ul className="list-disc pl-6 space-y-1">
                        {item.items.map((li, i) => (
                          <li key={i}>{li}</li>
                        ))}
                      </ul>
                    </div>
                  );
                }

                // Special text (contact)
                if (item.text) {
                  return <p key={idx}>{item.text}</p>;
                }

                // Simple item
                if (item.item) {
                  return <p key={idx}>{item.item}</p>;
                }

                return null;
              })}
            </div>
          </section>
        ))}
      </main>
    </>
  );
};

export default Terms_Conditions;
